module.exports = __webpack_public_path__ + "static/media/caregiver.657de0c5.png";